import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

export function getAcceptPage(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/acceptPage`,
        method: 'post',
        data
    })
}

export function getAddAccept(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}
// 编辑
export function getAcceptedit(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}
export function getAcceptDetail(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/detail`,
        method: 'post',
        data
    })
}

// 案件受理接口
export function auditAccept(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/audit`,
        method: 'post',
        data
    })
}
//下载模板
export function downloadAcceptTemplate() {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}
// 删除
export function deleteAccept(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}
// 导入

export function importAccept(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationCaseInfo/gl/v1.0.0/identificationCaseInfoImport`,
        method: 'post',
        data
    })
}